/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { AllAppsGetHelpPopoverView } from 'cchome-apps';
import './Helpnav.scss';

/* eslint-enable no-unused-vars */

export default class Helpnav extends Component {
	render() {
		return (
			<div className="helpNavContainer">
				<AllAppsGetHelpPopoverView {...this.props} />
			</div>
		);
	}
}
